import { EShopConfig, PaymentGateway } from 'proto/eshop/Basket_pb'

export function isConfigValid(config: EShopConfig.AsObject) {
	if (config.deliveryEnabled) return haveStableDelivery(config)
	return true
}

function haveStableDelivery(config: EShopConfig.AsObject) {
	let result = false
	config.paymentOptionsList.forEach(payment => {
		let haveDeliveryOption = false
		let haveStable = config.deliveryOptionsList.some(delivery => {
			return delivery.pricesList.some(price => {
				const paymentGateway = price.paymentGateway === payment.paymentGateway ||
					price.paymentGateway === PaymentGateway.NO_PAYMENT_GATEWAY
				if (paymentGateway) haveDeliveryOption = true
				return paymentGateway && !price.total && !price.productId
			})
		})
		if (!haveDeliveryOption) {
			console.error(`Payment option ${payment.name} doesn't have any available delivery options`)
		}
		if (!result) result = haveStable
	})
	if (!result) {
		console.error(`No delivery that's always available`)
	}
	return result
}
